// eslint-disable-next-line no-secrets/no-secrets
/**
 * Component that displays detailed formatted price information.
 *
 * @selector formatted-price-detail
 * @templateUrl ./formatted-price-detail.component.html
 * @changeDetection ChangeDetectionStrategy.OnPush
 * @standalone true
 * @imports NgStyle
 *
 * @property {CommonPriceCurrenciesFormatted} price$$ - The formatted price data.
 * @property {string} primaryCurrencyClasses$$ - CSS classes for the primary currency.
 * @property {PricesClasses} pricesClasses$$ - CSS classes for the prices.
 * @property {FormattedPriceStyles} pricesStyles$$ - Styles for the prices.
 * @property {CommonPriceCurrenciesFormatted} pricesFormatted$$ - Formatted prices.
 * @property {CommonPriceCurrenciesFormatted} secondaryPricesFormatted$$ - Formatted secondary prices.
 * @property {FormattedPriceOptions} options$$ - Options for formatting the prices.
 * @property {boolean} primaryCurrency$$ - Indicates if the primary currency is used in the alternative currency template.
 * @property {boolean} secundaryCurrency$$ - Indicates if the secondary currency is used in the alternative currency template.
 * @property {boolean} showAlternativeCurrency$$ - Indicates if the alternative currency is used.
 */

import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { FormattedPriceOptions, PricesClasses } from '../../models/product-prices.model';

import { CommonPriceCurrenciesFormatted } from '@frontend/common/currency';

@Component({
    selector: 'formatted-price-detail',
    templateUrl: './formatted-price-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ NgStyle ],
})
export class FormattedPriceDetailComponent {
    public price$$ = input<CommonPriceCurrenciesFormatted>();

    public primaryCurrencyClasses$$ = input<string>();

    public pricesClasses$$ = input<PricesClasses>();

    public pricesStyles$$ = input<Record<string, string>>();

    public pricesFormatted$$ = input<CommonPriceCurrenciesFormatted>();

    public secondaryPricesFormatted$$ = input<CommonPriceCurrenciesFormatted>();

    public options$$ = input<FormattedPriceOptions>();

    public primaryCurrency$$ = input<boolean>();

    public secundaryCurrency$$ = input<boolean>();

    public showAlternativeCurrency$$ = computed(() =>
        this.options$$()?.showAlternateCurrencies && this.pricesFormatted$$()?.secondaryCurrencies?.length > 0);
}
